import { CtaBand } from '@/components/home/CtaBand';
import { FaqAccordion } from '@/components/home/FaqAccordion';
import { FeaturesGrid } from '@/components/home/FeaturesGrid';
import { HighlightsBand } from '@/components/home/HighlightsBand';
import { HomeHero } from '@/components/home/HomeHero';
import { IndustriesRail } from '@/components/home/IndustriesRail';
import { LaunchSteps } from '@/components/home/LaunchSteps';
import { PricingPanel } from '@/components/home/PricingPanel';
import { QuickInstall } from '@/components/home/QuickInstall';
import { TestimonialsCarousel } from '@/components/home/TestimonialsCarousel';
import { WhyNeonCarts } from '@/components/home/WhyNeonCarts';
import { Container } from '@/components/ui/Container';

/**
 * The marketing home page.
 *
 * Every band is a component under `components/home` and every word one of them
 * says comes from `data/homeContent`, so this file is the running order and
 * nothing else.
 *
 * The bands that paint a background paint a translucent one. The site-wide
 * artwork on `body::before` sits behind every route, and an opaque full-bleed
 * section would cut it off at its own edges and leave a hard band across the
 * page. Cards inside a section are solid white; the sections themselves are
 * not.
 */
export function HomePage() {
  return (
    <>
      <HomeHero />
      <HighlightsBand />
      <FeaturesGrid />
      <IndustriesRail />
      <WhyNeonCarts />
      <QuickInstall />

      {/* The two paired rows. Each half is a self-contained panel, so they
          stack in source order on anything narrower than `lg` without either
          one needing to know it has a neighbour. */}
      <Container className="pb-8 sm:pb-10">
        <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2 lg:gap-5">
          <LaunchSteps />
          <PricingPanel />
        </div>

        <div className="mt-4 grid grid-cols-1 items-start gap-4 lg:mt-5 lg:grid-cols-2 lg:gap-5">
          <TestimonialsCarousel />
          <FaqAccordion />
        </div>
      </Container>

      <CtaBand />
    </>
  );
}
